function bindDownloadButton() {
	const downloadBtn = document.querySelector('.video-display-download');

	if (!downloadBtn) {
		return;
	}

	const video = downloadBtn.closest('.video-display');
	const data = { ... video.dataset };

	window._wq = window._wq || [];

	let asset;

	window._wq.push({
		id: data.videoId,
		onReady(video) {
			asset = video.data.media.assets.find(video => video.type === 'hd_mp4_video' && video.display_name === '1080p');
		},
	});

	downloadBtn.addEventListener('click', e => {
		e.preventDefault();

		if (!asset) {
			alert('Please try again momentarily.');
			return;
		}

		window.open(asset.url.replace(/\.bin$/, '.mp4') + '?disposition=attachment');
	})
}

export default function() {
	bindDownloadButton();
}
